import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const Pill = ({ label }) => (
  <span className="px-3 py-1.5 text-xs font-medium bg-white/5 border border-white/10 rounded-full text-gray-300
                   hover:bg-designColor/10 hover:border-designColor/30 hover:text-white transition-all duration-300 cursor-default">
    {label}
  </span>
);

const SkillsCell = () => {
  const { t } = useTranslation();

  const technical = [
    t("skills.skill1"),
    t("skills.skill2"),
    t("skills.skill3"),
    t("skills.skill4"),
    t("skills.skill5"),
  ];

  const tools = [
    t("skills.software6"),
    t("skills.software7"),
    t("skills.software8"),
    t("skills.software9"),
    t("skills.software10"),
  ];

  return (
    <motion.div
      variants={item}
      className="bento-cell p-5 lgl:p-6 flex flex-col gap-5
                 lgl:col-start-9 lgl:col-end-13 lgl:row-start-4 lgl:row-end-7"
    >
      <h3 className="text-lg font-bold text-white font-titleFont">
        {t("bento.skills.title")}
      </h3>

      <div>
        <span className="text-xs text-gray-500 uppercase tracking-wider mb-2 block">
          {t("bento.skills.technical")}
        </span>
        <div className="flex flex-wrap gap-2">
          {technical.map((s) => (
            <Pill key={s} label={s} />
          ))}
        </div>
      </div>

      <div>
        <span className="text-xs text-gray-500 uppercase tracking-wider mb-2 block">
          {t("bento.skills.tools")}
        </span>
        <div className="flex flex-wrap gap-2">
          {tools.map((s) => (
            <Pill key={s} label={s} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SkillsCell;
